export default __webpack_public_path__ + "static/media/joingame.a2153759.png";